<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de objetivos de venta</h2></v-toolbar-title></pre>
        </v-toolbar>
        <ObjetivoComponent
            :items="objetivos"
            :id_comercial="null"
            @save="(ele) => objetivos.push(ele)"
        >
        </ObjetivoComponent>
    </v-card>
</template>
<script>
import ObjetivoComponent from "./ObjetivoComponent.vue";

export default {
    data() {
        return {
            objetivos: [],
        };
    },
    created() {
        this.getObjetivos();
    },
    components: {
        ObjetivoComponent,
    },
    methods: {
        getObjetivos() {
            axios.get(`api/get-objetivos-ventas`).then(
                (res) => {
                    this.objetivos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los objetivos");
                }
            );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
